export const iconFontAwesomeAlphabetW = (
	<i className="fa-solid fa-w"></i>
);
